<template>
    <the-content>
        <div class="heading">
            <h1 class="heading-title">Статистика</h1>
        </div>

        <v-row>
            <v-col cols="12" sm="4">
                <v-card class="stat-card justify-center">
                    <v-card-text class="text-sm-center">
                        <div class="card-title">Всего посещений:</div>
                        <div class="card-value">{{overall.visits}}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card class="stat-card justify-center">
                    <v-card-text class="text-sm-center">
                        <div class="card-title">Всего активных абонементов:</div>
                        <div class="card-value">{{overall.active_cards}}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card class="stat-card justify-center">
                    <v-card-text class="text-sm-center">
                        <div class="card-title">Всего клиентов:</div>
                        <div class="card-value">{{overall.clients}}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" lg="6">
                <stat-cards/>
            </v-col>
            <v-col cols="12" lg="6">
                <stat-visits/>
            </v-col>
        </v-row>
        <v-row align="start">
            <v-col cols="12" lg="6">
                <stat-cards-by-type/>
            </v-col>
            <v-col cols="12" lg="6">
                <stat-active-cards/>
            </v-col>
        </v-row>
    </the-content>
</template>

<script>
    import statisticApi from '../api/statistic.api';
    import StatVisits from "../components/StatVisits";
    import StatCardsByType from "../components/StatCardsByType";
    import StatCards from "../components/StatCards";
    import StatActiveCards from "../components/StatActiveCards";

    export default {
        name      : "StatsPage",
        components: {StatActiveCards, StatCards, StatCardsByType, StatVisits},
        data() {
            return {
                overall: {
                    visits      : 0,
                    active_cards: 0,
                    clients     : 0,
                }
            }
        },
        created() {
            statisticApi.overall().then(({data}) => {
                Object.assign(this.overall, data);
            });
        }
    }
</script>

<style lang="scss">

    .v-card.stat-card {
        min-height: 100%;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;

        .card-title {
            font-size: 16px;
            line-height: 20px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        .card-value {
            font-size: 40px;
            line-height: 40px;
            font-weight: 600;
            color: #607D8B;
            margin-top: 10px;
        }

        .card-heading {

            .viewport-sm &,
            .viewport-md &,
            .viewport-lg &,
            .viewport-xl & {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;

                .card-title {
                    margin: 0 20px 0 0;
                }

                .v-input {
                    margin: 0 20px 0 0;
                    max-width: 230px;
                }

                .card-value {
                    margin: 0 0 0 auto;
                }
            }
        }


        .card-chart {

        }


        .card-chart-placeholder {
            text-align: center;
        }
    }
</style>
